@if (loading()) {
<div class="loading-overlay">
  <div class="spinner"></div>
</div>
}

<router-outlet />
